/**
 * FINAL: Erstellt und injiziert das komplette und detaillierte LD+JSON Schema dynamisch.
 */
function fwUpdateOfferSchema() {

    const existingSchema = document.getElementById('dynamic-product-schema');
    if (existingSchema) existingSchema.remove();

    const data = window.fwProductData;
    if (!data || !data.variants || data.variants.length === 0) return;

    const schemaData = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": data.title,
        "brand": { "@type": "Brand", "name": data.vendor },
        "description": data.description,
        "image": data.images,
        "offers": []
    };

    if (Array.isArray(data.additional_attributes) && data.additional_attributes.length > 0) {
        schemaData.additionalProperty = data.additional_attributes;
    }

    const commonOfferDetails = {
        "priceValidUntil": fwGetPriceValidUntil(1),
        "seller": { "@type": "Organization", "name": "Fasswulf" },
        "hasMerchantReturnPolicy": {
            "@type": "MerchantReturnPolicy",
            "applicableCountry": "DE",
            "returnPolicyCategory": "https://schema.org/MerchantReturnFiniteReturnWindow",
            "merchantReturnDays": 14,
            "returnMethod": "https://schema.org/ReturnByMail",
            "returnFees": "https://schema.org/ReturnFeesCustomerResponsibility"
        }
    };

    // --- SCHRITT 1: Standard-Angebote generieren ---
    if (window.hasSalesUnits && data.salesUnits && data.salesUnits.length > 0) {
        const smallestUnit = data.salesUnits.sort((a, b) => a.content - b.content)[0];
        if (smallestUnit) {
            const unitQuantity = smallestUnit.content;
            const shippingCost = fwGetShippingCostOfferSchema(data, unitQuantity);

            data.variants.forEach(variant => {
                const unitPrices = calculatePriceForQuantity(unitQuantity);
                const productTotalNetInCents = unitPrices.net - unitPrices.shipping;
                const productPriceGross = (productTotalNetInCents / 100) * (1 + data.taxRate);
                
                schemaData.offers.push({
                    "@type": "Offer",
                    "sku": variant.sku,
                    "url": `${data.url.split('?')[0]}?variant=${variant.id}`,
                    "price": productPriceGross.toFixed(2),
                    "priceCurrency": "EUR",
                    "availability": variant.available ? "http://schema.org/InStock" : "http://schema.org/OutOfStock",
                    "priceSpecification": {
                        "@type": "UnitPriceSpecification",
                        "price": (productPriceGross / unitQuantity).toFixed(2),
                        "priceCurrency": "EUR",
                        "unitText": data.salesUnitContentType
                    },
                    "shippingDetails": {
                    "@type": "OfferShippingDetails",
                    "shippingRate": {
                        "@type": "MonetaryAmount",
                        "value": shippingCost, // Deine Variable für die Versandkosten
                        "currency": "EUR"
                    },
                    "shippingDestination": {
                        "@type": "DefinedRegion",
                        "addressCountry": "DE" // ISO 3166-1 Alpha-2 Ländercode (hier: Deutschland)
                    }
                    },
                    ...commonOfferDetails
                });
            });
        }
    } else {
        const shippingCost = fwGetShippingCostOfferSchema(data, 1);
        data.variants.forEach(variant => {
            const productPriceGross = (variant.price / 100) * (1 + data.taxRate);
            schemaData.offers.push({
                "@type": "Offer",
                "sku": variant.sku,
                "url": `${data.url.split('?')[0]}?variant=${variant.id}`,
                "price": productPriceGross.toFixed(2),
                "priceCurrency": "EUR",
                "availability": variant.available ? "http://schema.org/InStock" : "http://schema.org/OutOfStock",
                "shippingDetails": {
                "@type": "OfferShippingDetails",
                "shippingRate": {
                    "@type": "MonetaryAmount",
                    "value": shippingCost, // Deine Variable für die Versandkosten
                    "currency": "EUR"
                },
                "shippingDestination": {
                    "@type": "DefinedRegion",
                    "addressCountry": "DE" // ISO 3166-1 Alpha-2 Ländercode (hier: Deutschland)
                }
                },
                ...commonOfferDetails
            });
        });
    }

    // --- SCHRITT 2: ZUSÄTZLICH das Mengen-Angebot hinzufügen ---
    const urlParams = new URLSearchParams(window.location.search);
    const currentQuantity = parseInt(urlParams.get('amount'), 10);
    const isBulkLoad = !isNaN(currentQuantity) && currentQuantity > 1;

    if (isBulkLoad) {
        const currentVariantId = urlParams.get('variant') || data.variants[0].id;
        const currentVariant = data.variants.find(v => v.id == currentVariantId);
        if (currentVariant) {
            let itemTierPriceNet = 0;
            data.bulkPrices.forEach(tier => {
                if (currentQuantity >= tier.qty) { itemTierPriceNet = tier.priceNet; }
            });
            
            if (itemTierPriceNet > 0) {
                const productTotalNet = itemTierPriceNet * currentQuantity;
                const productTotalGross = productTotalNet * (1 + data.taxRate);
                const itemTierPriceGross = itemTierPriceNet * (1 + data.taxRate);
                const shippingCost = fwGetShippingCostOfferSchema(data, currentQuantity);

                schemaData.offers.push({
                    "@type": "Offer",
                    "name": `Angebot für ${currentQuantity} Stück`,
                    "sku": `${currentVariant.sku}-${currentQuantity}`,
                    "url": `${data.url.split('?')[0]}?variant=${currentVariant.id}&amount=${currentQuantity}`,
                    "price": productTotalGross.toFixed(2),
                    "priceCurrency": "EUR",
                    "availability": currentVariant.available ? "http://schema.org/InStock" : "http://schema.org/OutOfStock",
                    // KORREKTUR: priceSpecification ist jetzt vollständig implementiert
                    "priceSpecification": {
                        "@type": "UnitPriceSpecification",
                        "price": itemTierPriceGross.toFixed(2),
                        "priceCurrency": "EUR",
                        "unitText": data.salesUnitContentType || "Stück"
                    },
                    "shippingDetails": {
                    "@type": "OfferShippingDetails",
                    "shippingRate": {
                        "@type": "MonetaryAmount",
                        "value": shippingCost, // Deine Variable für die Versandkosten
                        "currency": "EUR"
                    },
                    "shippingDestination": {
                        "@type": "DefinedRegion",
                        "addressCountry": "DE" // ISO 3166-1 Alpha-2 Ländercode (hier: Deutschland)
                    }
                    },
                    ...commonOfferDetails
                });
            }
        }
    }
    
    // --- SCHRITT 3: Das fertige Schema einfügen ---
    if (schemaData.offers.length > 0) {
        const script = document.createElement('script');
        script.type = 'application/ld+json';
        script.id = 'dynamic-product-schema';
        script.textContent = JSON.stringify(schemaData, null, 2);
        document.head.appendChild(script);
    }
}

function fwGetShippingCostOfferSchema(data, quantity) {
  if (!data || !data.weightPerItemKg || !Array.isArray(data.shippingRules)) return 0;

  const totalWeight = data.weightPerItemKg * quantity;

  const rule = data.shippingRules.find(r =>
    totalWeight >= r.minWeight && totalWeight <= r.maxWeight
  );

  if (!rule) return 0;

  const taxRate = data.taxRate || 0;
  const gross = rule.priceNet * (1 + taxRate);

  return Number(gross.toFixed(2));
}

function fwGetPriceValidUntil(years = 1) {
  const d = new Date();
  d.setFullYear(d.getFullYear() + years);
  return d.toISOString().split('T')[0]; // YYYY-MM-DD
}

